module.exports = "<span class=layout__button-view-text>{{text}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/layout/button/button.hbs
// module id = 700
// module chunks = 0